// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleBiViewer = {
  id: "bi-viewer",
  mrn: "//iam.api.mondoo.app/roles/bi-viewer",
  title: "BI Viewer",
  allowedActions,
} as const;

export type RoleBiViewer = typeof roleBiViewer;
